import React from 'react';
import './roadmap.scss';
const Roadmap = () => {
    return (
        <>
            <section className="main-rewards " id="roadmap">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-11 mx-auto">
                            <div className="row">

                                <div className="col-sm-12 text-center">
                                    <h2 className="white">NFTS
                                        ROADMAP</h2>
                                    {/* <p className="grey ptb20">Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi</p> */}
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-sm-12 text-center">
                                    <div className="center-seen">
                                        {/* <img src="\BlazeDexassets\roadmap.png" className="img-fluid d-none  d-sm-block d-md-block d-lg-block d-xl-block" alt="" />
                                <img src="\BlazeDexassets\roadmap-mobile.png" className="img-fluid d-block d-sm-none d-md-none d-lg-none d-xl-none" alt="" /> */}
                                        <div class="container p-0 pcRoadmap">
                                            <ul class="timeline text-white text-left my-5">

                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">1 - NFT ART CREATED:</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    DRIVEN BULLISH COLLECTION - 40 DESIGNS - 4000 TOTAL
                                                                </li>
                                                                <li >
                                                                    NFTS (RARITY LEVEL - COMMON)
                                                                </li>
                                                                <li >
                                                                    DRIVEN BULLISH COLLECTION - 40 DESIGNS - 4000 TOTAL
                                                                </li>
                                                                <li >
                                                                    DRIVEN MILLIONAIRE COLLECTION - 20 DESIGNS - 949
                                                                </li>
                                                                <li >
                                                                    DRIVEN TO THE MOON COLLECTION - 10 DESIGNS - 50
                                                                </li>
                                                                <li >
                                                                    TOTAL NFTS (RARITY LEVEL - RARE)
                                                                </li>
                                                                <li >
                                                                    DRIVEN WOLFPACK COLLECTION - 10 DESIGNS - 10 TOTAL
                                                                </li>
                                                                <li >
                                                                    DRIVEN#001 - 1 DESIGN - 1 TOTAL NFT (RARITY LEVEL - LEGENDARY)
                                                                </li>

                                                            </ul>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="timeline-badge"><i class="glyphicon glyphicon-check"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">2 - PERKS ATTACHED TO
                                                                NFTS:</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    1 BRAND NEW NFT WRAPPED MCLAREN
                                                                </li>
                                                                <li >
                                                                    11 ROLEX WATCHES
                                                                </li>
                                                                <li >
                                                                    11 ULTRA LUXURY ALL INCLUSIVE TRADING MASTERMIND
                                                                    TICKETS
                                                                </li>
                                                                <li >
                                                                    11 DRIVEN EVENT ALL ACCESS PASS
                                                                </li>
                                                                <li >
                                                                    61 3X3 NFT ART CANVAS
                                                                </li>
                                                                <li >
                                                                    61 DRIVEN TRADING SUMMIT VIP TICKETS
                                                                </li>
                                                                <li >
                                                                    1000 DRIVENVERSE LAUNCH PARTY TICKETS
                                                                </li>
                                                                <li >
                                                                    1000 DRIVEN NFT HOLDER EXCLUSIVE LUXURY STORE
                                                                </li>
                                                                <li >
                                                                    DISCOUNT CODES
                                                                </li>
                                                                <li >
                                                                    5000 DRIVENVERSE DAY PASSES
                                                                </li>
                                                                <li >
                                                                    5000 DRIVEN NFT HOLDER EXCLUSIVE LUXURY STORE ACCESS
                                                                </li> 

                                                            </ul>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge warning"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">3 - GIVE BACK ON THE WAY</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    2% OF ROYALTIES GO TO THE HARBOUR YOUTH TO HELP
                                                                    YOUTH VICTMS OF HUMAN TRAFFICKING
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="timeline-badge danger"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">4 - DROP 001 HAPPENS
                                                                LIVE IN LAS VEGAS</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    (1000 NFTS OPEN FOR MINTING) DRIVEN VEGAS
                                                                    EXPERIENCE AT BALLY’S LAS VEGAS APRIL 1ST AND 2ND
                                                                    2022.
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">5 - DROP 002 DRIVEN GLOBAL
                                                                MEMBERS GET ACCESS
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    (2000 NFTS OPEN FOR MINTING)
                                                                    SCHEDULED FOR SUNDAY APRIL 3RD 2022 9AM ET
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li>
                                                    <div class="timeline-badge danger"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">6 - DROP 003 PUBLIC ACCESS ON
                                                                OPENSEA
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    (2000 NFTS OPEN FOR MINTING)

                                                                </li>
                                                                <li >
                                                                    SCHEDULED FOR MONDAY APRIL 3RD 2022 9AM ET

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">7 - CLAIMING OPEN FOR
                                                                PHYSICAL PERKS
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    AT EACH DROP DATE. THE MCLAREN, THE ROLEX WATCHES, AND THE
                                                                    CANVAS WILL BE AVAILABLE TO BE CLAIMED ONCE ASSOCIATED NFTS
                                                                    ARE MINTED.

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="timeline-badge danger"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">8 - THE WOLFPACK MASTERMIND
                                                                ROLLS OUT</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    LAUNCH CALL SCHEDULED FOR APRIL 2022 WITH DRIVEN CEO CORY
                                                                    KROMRAY.

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">9 - NFTS HOLDERS EXCLUSIVE
                                                                MERCH NOW AVAILABLE
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    FIRST 3 ITEMS SCHEDULED FOR A SUPER LIMITED DROP MAY 2022

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="timeline-badge danger"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">10 - DRIVENVERSE DAYPASSES
                                                                OPEN FOR CLAIMING</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    SCHEDULED FOR JULY 2022

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">11 - DRIVENVERSE LAUNCH PARTY
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    SCHEDULED FOR AUGUST 2022
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="timeline-badge danger"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">12 - NFTS PHASE II
                                                                ANNOUNCEMENT</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    EARLY ACCESS, WHITELISTING, MERGING POSSIBILITIES FOR
                                                                    EXCLUSIVE GOLDEN CLUB ACCESS, PHASE II PERKS ANNOUNCED

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>




                                            </ul>
                                        </div>


                                        <div class="container p-0 mobileRoadmap">
                                            <ul class="timeline text-white text-left my-5">

                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">1 - NFT ART CREATED:</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <div class="timeline-body">
                                                                <ul className='default-li'>
                                                                    <li >
                                                                        DRIVEN BULLISH COLLECTION - 40 DESIGNS - 4000 TOTAL
                                                                    </li>
                                                                    <li >
                                                                        NFTS (RARITY LEVEL - COMMON)
                                                                    </li>
                                                                    <li >
                                                                        DRIVEN BULLISH COLLECTION - 40 DESIGNS - 4000 TOTAL
                                                                    </li>
                                                                    <li >
                                                                        DRIVEN MILLIONAIRE COLLECTION - 20 DESIGNS - 949
                                                                    </li>
                                                                    <li >
                                                                        DRIVEN TO THE MOON COLLECTION - 10 DESIGNS - 50
                                                                    </li>
                                                                    <li >
                                                                        TOTAL NFTS (RARITY LEVEL - RARE)
                                                                    </li>
                                                                    <li >
                                                                        DRIVEN WOLFPACK COLLECTION - 10 DESIGNS - 10 TOTAL
                                                                    </li>
                                                                    <li >
                                                                        DRIVEN#001 - 1 DESIGN - 1 TOTAL NFT (RARITY LEVEL - LEGENDARY)
                                                                    </li>

                                                                </ul>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge warning"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">2 - PERKS ATTACHED TO
                                                                NFTS:</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    1 BRAND NEW NFT WRAPPED MCLAREN
                                                                </li>
                                                                <li >
                                                                    11 ROLEX WATCHES
                                                                </li>
                                                                <li >
                                                                    11 ULTRA LUXURY ALL INCLUSIVE TRADING MASTERMIND
                                                                    TICKETS
                                                                </li>
                                                                <li >
                                                                    11 DRIVEN EVENT ALL ACCESS PASS
                                                                </li>
                                                                <li >
                                                                    61 3X3 NFT ART CANVAS
                                                                </li>
                                                                <li >
                                                                    61 DRIVEN TRADING SUMMIT VIP TICKETS
                                                                </li>
                                                                <li >
                                                                    1000 DRIVENVERSE LAUNCH PARTY TICKETS
                                                                </li>
                                                                <li >
                                                                    1000 DRIVEN NFT HOLDER EXCLUSIVE LUXURY STORE
                                                                </li>
                                                                <li >
                                                                    DISCOUNT CODES
                                                                </li>
                                                                <li >
                                                                    5000 DRIVENVERSE DAY PASSES
                                                                </li>
                                                                <li >
                                                                    5000 DRIVEN NFT HOLDER EXCLUSIVE LUXURY STORE ACCESS
                                                                </li>

                                                            </ul>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">3 - GIVE BACK ON THE WAY</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    2% OF ROYALTIES GO TO THE HARBOUR YOUTH TO HELP
                                                                    YOUTH VICTMS OF HUMAN TRAFFICKING
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge warning"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">4 - DROP 001 HAPPENS
                                                                LIVE IN LAS VEGAS</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    (1000 NFTS OPEN FOR MINTING) DRIVEN VEGAS
                                                                    EXPERIENCE AT BALLY’S LAS VEGAS APRIL 1ST AND 2ND
                                                                    2022.
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">5 - DROP 002 DRIVEN GLOBAL
                                                                MEMBERS GET ACCESS
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    (2000 NFTS OPEN FOR MINTING)
                                                                    SCHEDULED FOR SUNDAY APRIL 3RD 2022 9AM ET
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">6 - DROP 003 PUBLIC ACCESS ON
                                                                OPENSEA
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <div class="timeline-body">
                                                                <ul className='default-li'>
                                                                    <li >
                                                                        (2000 NFTS OPEN FOR MINTING)

                                                                    </li>
                                                                    <li >
                                                                        SCHEDULED FOR MONDAY APRIL 3RD 2022 9AM ET

                                                                    </li>
                                                                </ul>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge warning"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">7 - CLAIMING OPEN FOR
                                                                PHYSICAL PERKS
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    AT EACH DROP DATE. THE MCLAREN, THE ROLEX WATCHES, AND THE
                                                                    CANVAS WILL BE AVAILABLE TO BE CLAIMED ONCE ASSOCIATED NFTS
                                                                    ARE MINTED.

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">8 - THE WOLFPACK MASTERMIND
                                                                ROLLS OUT</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    LAUNCH CALL SCHEDULED FOR APRIL 2022 WITH DRIVEN CEO CORY
                                                                    KROMRAY.

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge warning"><i class="glyphicon glyphicon-credit-card"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">9 - NFTS HOLDERS EXCLUSIVE
                                                                MERCH NOW AVAILABLE
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    FIRST 3 ITEMS SCHEDULED FOR A SUPER LIMITED DROP MAY 2022

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">10 - DRIVENVERSE DAYPASSES
                                                                OPEN FOR CLAIMING</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    SCHEDULED FOR JULY 2022

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">11 - DRIVENVERSE LAUNCH PARTY
                                                            </h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    SCHEDULED FOR AUGUST 2022
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="timeline-inverted">
                                                    <div class="timeline-badge success"><i class="glyphicon glyphicon-thumbs-up"></i></div>
                                                    <div class="timeline-panel">
                                                        <div class="timeline-heading">
                                                            <h4 class="timeline-title">12 - NFTS PHASE II
                                                                ANNOUNCEMENT</h4>
                                                        </div>
                                                        <div class="timeline-body">
                                                            <ul className='default-li'>
                                                                <li >
                                                                    EARLY ACCESS, WHITELISTING, MERGING POSSIBILITIES FOR
                                                                    EXCLUSIVE GOLDEN CLUB ACCESS, PHASE II PERKS ANNOUNCED

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Roadmap;
